import { React } from 'react';
import { styled } from '@mui/system';
import Pagination from '@mui/material/Pagination';

const DisplayAndPaginationContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '28px',
});

const ItemsDisplayContainer = styled('div')({
  height: '365px',
});

const OuterContainer = styled('div')({
  display: 'flex',
  gap: '50px',
});

const CafeInfoContainer = styled('div')({
  display: 'flex',
  width: '202px',
  height: '30px',
  marginTop: '15px',
  marginLeft: '10px',
  gap: '5px',
});

const CafeName = styled('div')({
  fontFamily: 'Fjalla One',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '20px',
  color: '#000000',
  marginTop: '5px',
});

const PickCafeContainer = styled('div')({
  marginTop: '15px',
});

const AddCafe = styled('button')({
  color: '#fff',
  width: '55px',
  height: '23px',
  backgroundColor: '#AA9178',
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'Fjalla One',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '18px',
});

const PiginationArea = styled('div')({
  alignItems: 'center',
  marginLeft: '20px',
});

const DisplayAndPagination = ({
  data,
  selectedItems,
  itemInfo,
  totalPageNumber,
  page,
  onChange,
}) => {
  return (
    <DisplayAndPaginationContainer>
      <ItemsDisplayContainer>
        {data.map((item, index) => {
          return (
            <OuterContainer key={item._id}>
              <CafeInfoContainer>
                <img
                  src={item.attachments[0]?.url}
                  key={item._id}
                  style={{ width: '38.8px', height: '30px' }}
                />
                <CafeName>{item.cafeName}</CafeName>
              </CafeInfoContainer>
              <PickCafeContainer>
                {selectedItems.some((e) => e._id === item._id) ? (
                  <AddCafe
                    {...itemInfo({
                      item,
                      key: item._id,
                      style: {
                        backgroundColor: selectedItems.some((e) => e._id === item._id)
                          ? 'white'
                          : '',
                        color: selectedItems.some((e) => e._id === item._id) ? 'black' : 'normal',
                      },
                    })}
                  >
                    Added
                  </AddCafe>
                ) : (
                  <AddCafe
                    {...itemInfo({
                      item,
                      key: item._id,
                    })}
                  >
                    Add
                  </AddCafe>
                )}
              </PickCafeContainer>
            </OuterContainer>
          );
        })}
      </ItemsDisplayContainer>
      <PiginationArea>
        <Pagination
          count={totalPageNumber}
          siblingCount={0}
          boundaryCount={0}
          page={page}
          onChange={onChange}
          variant="outlined"
          shape="rounded"
          size="small"
          //sx={{ marginLeft: '50px', marginBottom: '100px', textAlign: 'center'}}
          sx={{
            '& > *': {
              justifyContent: 'center',
              display: 'flex',
            },
            marginLeft: '-30px',
          }}
        />
      </PiginationArea>
    </DisplayAndPaginationContainer>
  );
};

export default DisplayAndPagination;
